function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(46.666667%,48.235294%,70.196078%)",
      fillOpacity: 1
    },
    d: "M 4.050781 0 L 22.949219 0 C 25.1875 0 27 1.8125 27 4.050781 L 27 22.949219 C 27 25.1875 25.1875 27 22.949219 27 L 4.050781 27 C 1.8125 27 0 25.1875 0 22.949219 L 0 4.050781 C 0 1.8125 1.8125 0 4.050781 0 Z M 4.050781 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      strokeWidth: 6,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 155.036515 201.99932 L 97.03671 201.99932 C 95.629308 201.925246 94.444126 202.740058 93.999683 203.999313 L 67.036811 345.035875 C 67.036811 347.998828 69.999764 347.998828 69.999764 347.998828 L 99.999663 347.998828 C 103.03669 347.998828 103.03669 345.998835 103.03669 345.998835 L 109.999629 311.035989 L 137.036575 311.035989 C 179.036434 311.035989 199.999326 283.036084 205.036346 257.999131 C 209.999293 233.036252 205.999306 201.99932 155.036515 201.99932 Z M 167.999434 255.999138 C 163.999448 275.036111 151.036528 283.036084 133.036589 283.036084 L 115.03665 283.036084 L 125.999576 229.999225 L 143.999515 229.999225 C 171.036461 229.999225 169.999427 239.999192 167.999434 255.999138 Z M 167.999434 255.999138 ",
    transform: "matrix(0.0527346,0,0,0.0527346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      strokeWidth: 6,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 275.036111 311.035989 C 271.036124 311.035989 271.999084 307.036003 271.999084 307.036003 L 283.999043 245.999171 C 283.999043 237.999198 289.999023 229.999225 265.999104 231.036259 L 247.999165 231.036259 L 233.036252 309.035996 C 233.036252 309.035996 233.036252 311.998949 229.036266 311.998949 L 199.999326 311.998949 C 197.036373 311.998949 197.036373 309.035996 197.036373 309.035996 L 225.036279 167.999434 C 225.036279 167.999434 225.036279 165.999441 229.036266 165.999441 L 259.036164 165.999441 C 261.999117 165.999441 261.036158 169.036468 261.036158 169.036468 L 253.999144 203.036353 L 279.999057 203.036353 C 315.998936 203.036353 325.035942 219.999259 321.998915 239.999192 L 309.035996 309.035996 C 309.035996 309.035996 309.035996 311.998949 303.998976 311.998949 Z M 275.036111 311.035989 ",
    transform: "matrix(0.0527346,0,0,0.0527346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      strokeWidth: 6,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 154.999481 201.99932 L 96.999677 201.99932 C 95.666348 201.925246 94.481167 202.740058 94.036724 203.999313 L 66.999778 345.035875 C 66.999778 347.998828 70.036804 347.998828 70.036804 347.998828 L 100.036703 347.998828 C 102.999656 347.998828 102.999656 345.998835 102.999656 345.998835 L 110.03667 311.035989 L 136.999542 311.035989 C 178.9994 311.035989 200.036367 283.036084 204.999313 257.999131 C 210.036333 233.036252 206.036346 201.99932 154.999481 201.99932 Z M 168.036474 255.999138 C 164.036488 275.036111 150.999495 283.036084 132.999555 283.036084 L 114.999616 283.036084 L 126.036616 229.999225 L 144.036555 229.999225 C 170.999427 229.999225 170.036468 239.999192 168.036474 255.999138 Z M 168.036474 255.999138 ",
    transform: "matrix(0.0527346,0,0,0.0527346,12.603515,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/php.28380a9420ea7479d95ee377f025f4a3.svg";
export { ForwardRef as ReactComponent };